import { t } from 'app/i18l'
import { Alert, Platform } from 'react-native'
import {
  confirmationAlertWeb,
  errorAlertWeb,
  informationAlertWeb,
} from './alert.web'

const alert = Alert.alert

export function confirmationAlert(
  title: string,
  message?: string
): Promise<boolean> {
  if (Platform.OS === 'web') {
    return confirmationAlertWeb(title, message)
  }
  return new Promise(resolve => {
    alert(
      title,
      message,
      [
        {
          text: t('no'),
          style: 'cancel',
          onPress: () => resolve(false),
        },
        {
          text: t('yes'),
          style: 'default',
          onPress: () => resolve(true),
        },
      ],
      { cancelable: true }
    )
  })
}

export function errorAlert(error: Error, title?: string) {
  if (Platform.OS === 'web') {
    return errorAlertWeb(error, title)
  }
  alert(
    title ?? t('error'),
    error.message,
    [
      {
        text: 'OK',
        style: 'default',
      },
    ],
    { cancelable: false }
  )
}

export function informationAlert(title: string, message: string) {
  if (Platform.OS === 'web') {
    return informationAlertWeb(title, message)
  }
  alert(
    title,
    message,
    [
      {
        text: 'OK',
        style: 'default',
      },
    ],
    { cancelable: false }
  )
}
